import React from 'react';
export * from './Article';
export const Article = React.lazy(() => import('./Article'));
export const Settings = React.lazy(() => import('./Settings'));
export const Calendar = React.lazy(() => import('./Calendar'));
export const Page = React.lazy(() => import('./Page'));
export const Home = React.lazy(() => import('./Home'));
export const Developer = React.lazy(() => import('./Developer'));
export const ArticleCategory = React.lazy(() => import('./ArticleCategory'));
export const NotFound = React.lazy(() => import('./NotFound'));
export const Author = React.lazy(() => import('./Author'));